import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const Grafica = ({ ocupacion, cupo }) => {
  const graphColor = (ocu, cupo) => {
    if (ocu <= Math.floor(cupo * 0.5)) {
      return 'rgba(0, 153, 51, 1)';
    }
    if (ocu > Math.floor(cupo * 0.5) && ocu <= Math.floor(cupo * 0.75)) {
      return 'rgba(244, 201, 28, 1)';
    }
    if (ocu > Math.floor(cupo * 0.75)) {
      return 'rgba(255, 0, 0, 1)';
    }
  };

  const options = {
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  const data = {
    labels: ['personas'],
    datasets: [
      {
        label: 'personas',
        data: [ocupacion],
        backgroundColor: [graphColor(ocupacion, cupo)],
        borderColor: [graphColor(ocupacion, cupo)],
        borderWidth: 1,
      },
    ],
  };
  return (
    <div style={{ width: '400px' }}>
      <Bar
        data={data}
        options={options}
      />
    </div>
  );
};

export default Grafica;
